import { format } from "date-fns";
import { Lock, Link } from "lucide-react";
import FileIcon from "@/assets/icons/file.svg?react";
import { Badge } from "@/components/ui/badge";
import { getFile } from "@/api/s3.api";
import { ExpeditionDocumentFileBoDto, ExpeditionDocumentFileDto } from "@/types/api/api-types";
import { FileTypeEnum } from "@/constants/enums/fileType.enum";
import { useFileTypeLabels } from "@/hooks/useEnumLabels";

type DocumentListItemProps = {
  file: ExpeditionDocumentFileBoDto | ExpeditionDocumentFileDto;
  showDetailsInfo?: boolean;
};

export const DocumentListItem = ({ file, showDetailsInfo = true }: DocumentListItemProps) => {
  const fileTypeLabels = useFileTypeLabels();
  const handleClick = async () => {
    const url = await getFile(file.path, file.name);
    window.open(url, "_blank");
  };

  const typeLabel = fileTypeLabels[file.type as FileTypeEnum] ?? file.type;
  const formattedDate = format(new Date(file.createdAt), "dd/MM/yyyy à HH:mm");

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex w-full items-start gap-3 rounded-md px-3 py-1.5 text-left transition-colors hover:bg-gray-200"
    >
      <div className="shrink-0 pt-0.5">
        <FileIcon className="size-4 text-gray-500" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <p className="text-sm font-medium break-words text-gray-800">{file.name}</p>
        {showDetailsInfo && (
          <div className="flex flex-wrap items-center gap-1.5">
            <Badge variant="lightGray" className="px-1.5 py-0 text-[10px]">
              {typeLabel}
            </Badge>
            <span className="text-[11px] text-gray-400">{formattedDate}</span>
            {"isPrivate" in file && file.isPrivate && <Lock className="size-3 text-gray-400" />}
            {"sendViaApi" in file && file.sendViaApi && <Link className="size-3 text-gray-400" />}
          </div>
        )}
      </div>
    </button>
  );
};
